module.exports = __webpack_public_path__ + "static/media/Sound of Moosic.113be170.png";